import { render, staticRenderFns } from "./simplifyShopFee.vue?vue&type=template&id=4641631b&scoped=true"
import script from "./simplifyShopFee.vue?vue&type=script&lang=js"
export * from "./simplifyShopFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyShopFee.vue?vue&type=style&index=0&id=4641631b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641631b",
  null
  
)

export default component.exports